import { Button, Checkbox, Form, Icon, Input, message } from 'antd';
import { FormComponentProps } from 'antd/lib/form';
import * as React from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import 'src/assets/less/login.less';
import HeaderLogin from 'src/components/layouts/HeaderLogin';
import { ILoginParam } from 'src/entity/LoginParam';
import { RouterConfig } from 'src/routers/urlConfig';
import I18N from 'src/services/I18NService';
import StorageService from 'src/services/StorageService';
import { OperatingService } from '../../../services/OperatingService';
import { clearSessionData } from 'src/redux/actions';

interface ILoginFormProps extends FormComponentProps, RouteComponentProps {
  authLogin: (authRequest: ILoginParam) => Promise<boolean>;
  getUserInfo: () => Promise<void>;
  updateMenu: (path: string) => void;
  dispatch: React.Dispatch<any>;
}

class LoginForm extends React.Component<ILoginFormProps, ILoginParam> {
  // readonly state: Readonly<ILoginParam> = {
  //   username: '',
  //   password: '',
  //   remember: true,
  // };

  constructor(props: ILoginFormProps) {
    super(props);

    clearSessionData(this.props.dispatch);
  }

  UNSAFE_componentWillMount() {
    this.initUserStorage();
  }

  initUserStorage = () => {
    let [username, password, remember] = ['', '', true];
    const obj = StorageService.getUserStorage();
    if (!!obj) {
      username = obj.username || '';
      password = obj.password || '';
      remember = obj.remember || true;
    }
    this.setState({
      username,
      password,
      remember,
    });
  };

  handleSubmit = (e: React.SyntheticEvent) => {
    e.preventDefault();
    this.props.form.validateFields(async (err, data: ILoginParam) => {
      if (!err) {
        try {
          // StorageService.removeItem('persist:root');
          if (!!data.remember) {
            StorageService.setUserStorage(data);
          } else {
            StorageService.setUserStorage({
              username: data.username,
              remember: data.remember,
            });
          }

          const res = await this.props.authLogin(data);
          if (!!res) {
            OperatingService.addOperating('login');
            await this.props.getUserInfo();
            this.props.updateMenu(RouterConfig.Urls.default);
            this.props.history.push(RouterConfig.Urls.default);
          } else {
            message.error(I18N.get('err_login_failure'));
          }
        } catch (error) {
          if (!!error.response) {
            message.error(JSON.stringify(error.response.data));
          } else {
            message.error(I18N.get('err_login_failure'));
          }
        }
      }
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <div className="login-box">
        <HeaderLogin />
        <div className="login">
          <div className="login-form-box">
            <div className="login-logo">
              <div className="login-name">{I18N.get('login_account')}</div>
            </div>
            <Form onSubmit={this.handleSubmit} className="login-form">
              <Form.Item>
                {getFieldDecorator(`username`, {
                  initialValue: this.state.username,
                  rules: [{ required: true, message: I18N.get('err_no_userName') }],
                })(<Input prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />} placeholder={I18N.get('login_userName')} />)}
              </Form.Item>
              <Form.Item>
                {getFieldDecorator(`password`, {
                  initialValue: this.state.password,
                  rules: [{ required: true, message: I18N.get('err_no_password') }],
                })(<Input prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />} type="password" placeholder={I18N.get('login_pwd')} />)}
              </Form.Item>
              <Form.Item>
                {getFieldDecorator(`remember`, {
                  valuePropName: 'checked',
                  initialValue: this.state.remember,
                })(<Checkbox>{I18N.get('login_remember_pwd')}</Checkbox>)}
                <Link to={RouterConfig.Urls.reset} className="login-form-forgot">
                  {I18N.get('login_reset_pwd')}
                </Link>
                <Button type="primary" htmlType="submit" className="login-form-button">
                  {I18N.get('common_login')}
                </Button>
                {/* <a onClick={this.changeUserType} className="login-form-forgot">
                                    {this.state.isAgent ? I18N.get('login_drug_store') : I18N.get('login_account')}
                                </a> */}
              </Form.Item>
            </Form>
          </div>
        </div>
      </div>
    );
  }
}

const LoginPage = Form.create<ILoginFormProps>()(LoginForm);
export default LoginPage;



// WEBPACK FOOTER //
// ./src/components/views/Login/LoginPage.tsx